import { render, staticRenderFns } from "./FooterComponentEdunetke.vue?vue&type=template&id=a02eae78&scoped=true"
import script from "./FooterComponentEdunetke.vue?vue&type=script&lang=ts"
export * from "./FooterComponentEdunetke.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentEdunetke.vue?vue&type=style&index=0&id=a02eae78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02eae78",
  null
  
)

export default component.exports